<div style="position: relative">
  <div class="toggle-position">
    <p-selectButton
      [options]="[
        { label: 'Old Style', value: 0 },
        { label: 'New Style', value: 1 }
      ]"
      (onChange)="toggleView($event)"
      [(ngModel)]="viewType"
    ></p-selectButton>
  </div>
</div>
